// English translation file
export default {
  // Common
  common: {
    loading: 'Loading...',
    submit: 'Submit',
    cancel: 'Cancel',
    confirm: 'Confirm',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    close: 'Close',
    search: 'Search',
    reset: 'Reset',
    pleaseInput: 'Please enter',
    pleaseSelect: 'Please select',
    operation: 'Operation',
    status: 'Status',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    remark: 'Remark',
    success: 'Operation successful',
    error: 'Operation failed',
    warning: 'Warning',
    info: 'Info'
  },
  // Personal Center
  personalCenter: {
    pageTitle: 'Account Information',
    username: 'Username',
    email: 'Email',
    mobile: 'Mobile',
    password: 'Password',
    language: 'Language',
    languageDesc: 'Select your preferred communication language',
    lastLogin: 'Last Login',
    notSet: 'Not set',
    notBound: 'Not bound',
    bound: 'Bound',
    goToBind: 'Go to bind',
    bind: 'Bind',
    rebind: 'Rebind',
    modify: 'Modify',
    bindEmail: 'Bind Email',
    bindMobile: 'Bind Mobile',
    rebindMobile: 'Rebind Mobile',
    modifyUsername: 'Modify Username',
    modifyPassword: 'Modify Password',
    verifyMethod: 'Verification Method',
    verifyAccount: 'Verification Account',
    mobileVerify: 'Mobile Verification',
    emailVerify: 'Email Verification',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    passwordPlaceholder: '6-12 characters, including uppercase',
    confirmPasswordPlaceholder: 'Please enter new password again',
    // Validation messages
    pleaseInputEmail: 'Please enter email',
    emailFormatError: 'Email format is incorrect',
    pleaseInputMobile: 'Please enter mobile number',
    mobileFormatError: 'Mobile number format is incorrect',
    pleaseInputUsername: 'Please enter username',
    usernameLengthError: 'Username length must be 2-20 characters',
    pleaseSelectVerifyMethod: 'Please select verification method',
    pleaseInputNewPassword: 'Please enter new password',
    passwordLengthError: 'Length must be 6-12 characters',
    passwordComplexityError: 'Must include uppercase, lowercase and special characters',
    pleaseConfirmNewPassword: 'Please confirm new password',
    passwordMismatchError: 'Passwords do not match',
    // Message prompts
    pleaseBindMobileOrEmail: 'Please bind mobile or email first',
    pleaseInputVerifyAccount: 'Please bind verification account first',
    pleaseInputReceiverAccount: 'Please enter the account to receive verification code',
    getUserInfoFailed: 'Failed to get user information',
    languageChangeFailed: 'Failed to change language'
  },
  // Agent User Detail
  agentUser: {
    phone: 'Phone',
    accountBalance: 'Account Balance',
    depositAmount: 'Deposit Amount',
    email: 'Email',
    registerTime: 'Register Time',
    historyTradeAmount: 'History Trade Amount',
    tradeAccount: 'Trade Account',
    accountName: 'Account Name',
    balance: 'Balance',
    tradeLeverage: 'Trade Leverage',
    historyTradeVolume: 'History Trade Volume',
    addTime: 'Add Time',
    loadDetailFailed: 'Failed to load detail',
    operateAccount: 'Operate Account',
    role: {
      1: 'Platform',
      2: 'Contractor',
      3: 'Special Market Maker',
      4: 'Ordinary Market Maker',
      5: 'Agent',
      6: 'User'
    }
  },
  // Withdraw
  withdraw: {
    pageTitle: 'Withdraw',
    withdraw: 'Withdraw',
    dialog: {
      title1: 'Withdraw',
      title2: 'Confirm Withdraw Information',
      amount: 'Withdraw Amount',
      amountPlaceholder: 'Please enter withdraw amount',
      walletBalance: 'Wallet Balance',
      deductionDetails: 'Deduction Details',
      type: 'Type',
      originalBalance: 'Original Balance',
      deductedAmount: 'Deducted Amount',
      remaining: 'Remaining',
      totalDeducted: 'Total Deducted',
      channel: 'Channel',
      withdrawAmount: 'Withdraw Amount',
      walletAddress: 'Wallet Address',
      walletAddressPlaceholder: 'Please enter wallet address',
      beneficiaryName: 'Beneficiary Name',
      beneficiaryNamePlaceholder: 'Please enter beneficiary name',
      bankName: 'Bank Name',
      bankNamePlaceholder: 'Please enter bank name',
      swiftCode: 'SWIFT Code',
      swiftCodePlaceholder: 'Please enter SWIFT code',
      bankAddress: 'Bank Address',
      bankAddressPlaceholder: 'Please enter bank address',
      bankAccount: 'Bank Account',
      bankAccountPlaceholder: 'Please enter bank account',
      beneficiaryEnname: 'Beneficiary English Name',
      beneficiaryEnnamePlaceholder: 'Please enter beneficiary English name',
      bankTipsTitle: 'Warm Reminder',
      bankTipsContent: 'It is recommended to use large commercial banks such as ICBC, BOC, CCB, CMB, PSBC, or BOCOM. Rural commercial banks may not be able to receive the transfer. Only single-currency UnionPay cards are supported. A single-currency UnionPay card is a debit card with only UnionPay logo. Cards with both UnionPay and VISA or MasterCard logos cannot receive transfers. To ensure normal withdrawal, please use your own bank card.',
      nextStep: 'Next Step',
      confirmWithdraw: 'Confirm Withdraw',
      submitSuccess: 'Withdraw application submitted',
    },
    wallet: {
      feeHandling: 'Fee Handling',
      pointDiff: 'Point Diff',
      service: 'Service',
      risk: 'Risk',
      profit: 'Head Position',
      headPosition: 'Head Position',
      available: 'Available',
    },
    table: {
      channelName: 'Channel Name',
      channelFee: 'Channel Fee',
      apiUrl: 'API URL',
      apiAppid: 'API Appid',
      status: 'Status',
    },
  },
}
